// export const endpoint =
//   "https://mendel3.bii.a-star.edu.sg/METHODS/corona/gamma/MUTATIONS/data/";
export const endpoint =process.env.REACT_APP_API_URL;
  // "http://localhost/gisaid/test/data/";


